import { render, staticRenderFns } from "./TelInput.vue?vue&type=template&id=133144f5&lang=pug&"
import script from "./TelInput.vue?vue&type=script&lang=js&"
export * from "./TelInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports